import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';

class NotFound extends Component {
  render() {
    return(
      <s-container>
        <h1> <LanguageStringResolver string="pageNotFound_title" /></h1>
        <button className="primary"><Link to="/" ><LanguageStringResolver string="pageNotFound_button" /></Link></button>
      </s-container>
    );
  }
}

export default NotFound;